
import React from 'react';
import { formatText, cleanMarkdownSyntax } from '@/utils/report';
import Heading from '@/components/ui/heading';

type HeadingLevel = 'h2' | 'h3';

type SectionHeadingProps = {
  text: string;
  level: HeadingLevel;
  className?: string;
};

/**
 * Renders a section heading with consistent styling
 * Ensures all headings have clean formatting with no markdown symbols
 */
const SectionHeading = ({ text, level, className = '' }: SectionHeadingProps) => {
  // Convert string heading level to number
  const numericLevel = parseInt(level.substring(1)) as 2 | 3;
  
  // Clean and format the text before rendering - remove ALL formatting
  let cleanedText = text
    .replace(/^#+\s+/gm, '') // Remove heading markers
    .replace(/\*\*/g, '')    // Remove bold formatting
    .replace(/\*/g, '')      // Remove italic formatting
    .replace(/#/g, '')       // Remove any # characters
    .trim();
  
  // Apply consistent heading styles based on level - using a brighter blue for better visibility
  const baseStyle = level === 'h2' 
    ? "text-xl font-semibold text-[#0EA5E9] leading-relaxed mb-6 mt-8"
    : "text-lg font-medium text-[#38BDF8] leading-relaxed mb-4 mt-6";
  
  return (
    <Heading
      level={numericLevel}
      className={`${baseStyle} ${className}`}
    >
      {cleanedText}
    </Heading>
  );
};

export default SectionHeading;
